import { styled } from 'baseui';

export const Rotate = styled("div", {
    animationDuration: "2.0s",
    animationIterationCount: "infinite",
    animationTimingFunction: 'linear',
    display: 'flex',
    animationName: {
        from: {
            transform: "rotate(0deg)",

        },
        to: {
            transform: "rotate(359deg)"
        }
    }
});